export default 'we-spin';
